export enum ApiErrors {
  AssembleiaNaoIniciou = 'EVNOTINI01',
  AssembleiaEncerrada = 'EVNCLOSE01',
  PautaNaoLiberadaParaVotacao = 'PANOTOPN01',
  SituacaoIB = 'ERRIBLOG01',
  PertencerIsPresent = 'CONASPRE01',
  PertencerNotPresent = 'CONASNOT01',
  VotosInconsistentes = 'QTDVTINC01',
  VotosInconsistentesHibrida = 'MDHBRDNCST01',
  EventoNaoEncontrado = 'EVNOTFOU01',
}
